<template>
  <div class="card">
    <div class="title">
      <el-row>
        <el-col :span="12">
          <h3>{{title}}</h3>
          <div class="sub-title">
            {{subTitle}}
            <slot name="sub-title"></slot>
          </div>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <slot name="right-menu"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="content" :style="{width:contentWidth}">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "i-card",
    props: {
      title: {
        type: String,
        default: '卡片标题'
      },
      subTitle: {
        type: String,
        default: ''
      },
      contentWidth: {
        type: String,
        default: '100%'
      },
    }
  }
</script>

<style scoped lang="less">
  .card {
    width: 100%;
    background: #fff;
    padding: 20px;
    box-shadow: 0 1px 2px rgba(150, 150, 150, 0.3);
    margin-bottom: 30px;
    border-radius: 5px;
  }

  .title {
    font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", "\9ED1\4F53", Arial, sans-serif;
    margin-bottom: 30px;
  }

  .title h3 {
    display: inline-block;
    margin-right: 20px;
    font-size: 20px;
    font-weight: normal;
  }

  .sub-title {
    display: inline-block;
    font-size: 14px;
    color: #9a9a9a;
  }

  .right-menu {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/i-card.vue